// extracted by mini-css-extract-plugin
module.exports = {"info":"ShareStatusSelector__info___1a5KF","dropdown":"ShareStatusSelector__dropdown___1GDz7"};